import { Inset } from '@doordash/design-language';
export var Sizes = {
  Small: Inset.Sizes.XSmall,
  Medium: Inset.Sizes.Small,
  Large: Inset.Sizes.Large
};